// Copyright (c) 2017 Deere & Company

import AuditClaims, {getDefaultState as getAuditClaimsDefaultState} from './audit-claims';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    claims: AuditClaims,
    claimsFiltered: AuditClaims,
    facets: Facets,
    isInitialLoad: t.Boolean,
    searchFilters: SearchFilters
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        claims: getAuditClaimsDefaultState(),
        claimsFiltered: getAuditClaimsDefaultState(),
        facets: getFacetsDefaultState(),
        isInitialLoad: true,
        searchFilters: getSearchFiltersDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/state/index.js